export enum EUsersQueryKey {
  USERS = 'USERS',
  USER = 'USER',
  CURRENT_USER = 'CURRENT_USER',
  USER_DEALERSHIP_APPLICATION = 'USER_DEALERSHIP_APPLICATION',
  USER_PERMISSIONS = 'USER_PERMISSIONS',
  SEARCH_USER = 'SEARCH_USER',
}
